import moment from 'moment'
import { Link } from 'found'
import Carousel from 'nuka-carousel'
import { Helmet } from 'react-helmet'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 
import LazyLoad from 'react-lazy-load'
import jQuery from 'jquery'

import { msToReadingTime } from '../../utils'

import Shopify from '../../shopify'
// import ProductPreview from './product-preview'

// import artboard33Icon from '../../images/Artboard-33.svg'
import greyTimeIcon from '../../images/grey_time.svg'

class ProductPage extends Component {

    constructor(props) {
        super(props)
        this.state = { slideIndex: 0, shopifyProduct: props.shopifyProduct }
    }

    componentDidMount() {
        Shopify.createComponent('product', {
            id: [this.state.shopifyProduct],
            node: document.getElementById('target-product'),
            options: {
                "cart": {
                    "popup": false,
                    "text": { "currency": "EUR" },
                    "styles": {
                        "button": { "background-color": "red" }
                    }
                },
                "product": {
                    "iframe": false,
                    "templates": {
                        "button": '<div class="button small primary book-cta w-inline-block" data-element="product.buttonWrapper"><button style="background: none;" {{#data.buttonDisabled}}disabled{{/data.buttonDisabled}} class="text-block-3" data-element="product.button">{{data.buttonText}}</button><img alt="" src="" style="margin-left: 12px" width="10px" data-w-id="5aa351f4-adf5-6966-206d-069186f7cf15" class="image-59" /></div>'
                    },
                    "text": {
                        "button": "ADD TO BASKET",
                    },
                    "contents": {
                        "img": false,
                        "imgWithCarousel": false,
                        "title": false,
                        "variantTitle": false,
                        "price": false,
                        "description": false,
                        "buttonWithQuantity": false,
                        "quantity": false,
                        "footer": false,
                    },
                    "classes": {
                        "wrapper": 'button small secondary w-inline-block',
                        "button": 'text-block-3',
                    },
                },
            }
        }).then((product) => {
            this.setState({ product })
        })

        if (this.props.shopifyDigitalProduct) {
            Shopify.createComponent('product', {
                id: [this.props.shopifyDigitalProduct],
                node: document.getElementById('target-digital-product'),
                options: {
                    "cart": {
                        "popup": false,
                        "text": { "currency": "EUR" },
                        "styles": {
                            "button": { "background-color": "red" }
                        }
                    },
                    "product": {
                        "iframe": false,
                        "templates": {
                            "button": '<div class="button small primary book-cta w-inline-block" data-element="product.buttonWrapper"><button style="background: none;" {{#data.buttonDisabled}}disabled{{/data.buttonDisabled}} class="text-block-3" data-element="product.button">{{data.buttonText}}</button><img alt="" src="" style="margin-left: 12px" width="10px" data-w-id="5aa351f4-adf5-6966-206d-069186f7cf15" class="image-59" /></div>'
                        },
                        "text": {
                            "button": "ADD TO BASKET",
                        },
                        "contents": {
                            "img": false,
                            "imgWithCarousel": false,
                            "title": false,
                            "variantTitle": false,
                            "price": false,
                            "description": false,
                            "buttonWithQuantity": false,
                            "quantity": false,
                            "footer": false,
                        },
                        "classes": {
                            "wrapper": 'button small secondary w-inline-block',
                            "button": 'text-block-3',
                        },
                    },
                }
            }).then((product) => {
                this.setState({ digitalProduct: product })
            })
        }

        if (this.props.shopifyBundle) {
            Shopify.createComponent('product', {
                id: [this.props.shopifyBundle],
                node: document.getElementById('target-product-bundle'),
                options: {
                    "cart": {
                        "popup": false,
                        "text": { "currency": "EUR" },
                        "styles": {
                            "button": { "background-color": "red" }
                        }
                    },
                    "product": {
                        "iframe": false,
                        "templates": {
                            "button": '<div class="button small primary book-cta w-inline-block" data-element="product.buttonWrapper"><button style="background: none;" {{#data.buttonDisabled}}disabled{{/data.buttonDisabled}} class="text-block-3" data-element="product.button">{{data.buttonText}}</button><img alt="" src="" style="margin-left: 12px" width="10px" data-w-id="5aa351f4-adf5-6966-206d-069186f7cf15" class="image-59" /></div>'
                        },
                        "text": {
                            "button": "ADD TO BASKET",
                        },
                        "contents": {
                            "img": false,
                            "imgWithCarousel": false,
                            "title": false,
                            "variantTitle": false,
                            "price": false,
                            "description": false,
                            "buttonWithQuantity": false,
                            "quantity": false,
                            "footer": false,
                        },
                        "classes": {
                            "wrapper": 'button small secondary w-inline-block',
                            "button": 'text-block-3',
                        },
                    },
                }
            }).then(product => this.setState({ variantProduct: product }))
        }
    }

    componentDidUpdate() {

    }

    getPrice = (product) => {
        if (!product || !product.selectedVariant || !product.selectedVariant.price.amount)
            return 0;
        // console.log("PRODUCT",product);
        const d = parseFloat(product.selectedVariant.price.amount)
        const r = Math.round(d)
        return d === r ? r : d
    }

    getSimplifiedName = (product) => {
        if (!product || !product.model || !product.model.title)
            return "";

        const name = product.model.title

        if (name.search(/bundle/gi) !== -1) {
            return "VOLUME " + name.match(/[0-9]+/gi).join(' + ')
        }
        return name
    }

    getComparePrice = (product) => {
        if (!product || !product.selectedVariant || !product.selectedVariant.compareAtPrice)
            return 0;
        const d = parseFloat(product.selectedVariant.compareAtPrice.amount)
        const r = Math.round(d)
        return d === r ? r : d
    }

    parseDate(input, format) {
        format = format || 'yyyy-mm-dd'; // default format
        var parts = input.match(/(\d+)/g),
            i = 0, fmt = {};
        // extract date-part indexes from the format
        format.replace(/(yyyy|dd|mm|HH|MM)/g, function (part) { fmt[part] = i++; });

        return new Date(parts[fmt['yyyy']], parts[fmt['mm']] - 1, parts[fmt['dd']], parts[fmt['HH']], parts[fmt['MM']]);
    }

    render() {
        const isPreSale = this.props.releaseDate && (new Date(this.props.releaseDate) > new Date())
        const hasNominations = this.props.nominationsUntil &&
            (new Date() < this.parseDate(this.props.nominationsUntil, 'yyyy-mm-ddTHH:MM:00 '))

        // let isMAc = navigator.userAgent.includes('Mac') || navigator.userAgent.includes('iOS');
        var blockLazy = (/blocklazy/gi).test(window.location.href);

        // console.log('ALL',this.props);
        return (
            <div>
                <Helmet>
                    <title>{this.props.seo.title ? this.props.seo.title : "Startup Guide - " + this.props.name}</title>
                    <meta content={this.props.seo.description ? this.props.seo.description : this.props.summary} name="description" />

                    <meta content="website" property="og:type" />
                    <meta content={this.props.generic && this.props.generic.title ? this.props.generic.title : this.props.name} property="og:title" />
                    <meta content={this.props.generic && this.props.generic.description ? this.props.generic.description : this.props.summary} property="og:description" />
                    <meta content={this.props.generic && this.props.generic.image ? this.props.generic.image : this.props.picture} property="og:image" />
                    <meta property="og:url" content={"https://startupguide.com/shop/startup-guide-" + this.props.slug}></meta>
                    <meta property="og:site_name" content="StartupGuide"></meta>

                    <meta name="twitter:card" content={this.props.twitter && this.props.twitter.type.includes('Standard') ? 'summary' : 'summary_large_image'}></meta>
                    <meta name="twitter:site" content="@StartupGuideHQ"></meta>
                    <meta name="twitter:creator" content={this.props.twitter && this.props.twitter.handle ? this.props.twitter.handle : '@StartupGuideHQ'}></meta>
                    <meta name="twitter:title" content={this.props.twitter && this.props.twitter.title ? this.props.twitter.title : "Categorias"}></meta>
                    <meta name="twitter:description" content={this.props.twitter && this.props.twitter.description ? this.props.twitter.description : "Categorias"}></meta>
                    <meta name="twitter:image" content={this.props.twitter && this.props.twitter.image ? this.props.twitter.image : this.props.picture}></meta>

                    <script type='application/ld+json'>{`
                    {
                      "@context": "http://www.schema.org",
                      "@type": "product",
                      "name": "`+ this.props.name + `",
                      "identifier": "`+ this.props.name + `",
                      "description": "`+ this.props.summary + `",
                      "url": "https://startupguide.com/shop/startup-guide-`+ this.props.slug + `",
                      `+ (this.props.releaseDate ? `"releaseDate": "` + this.props.releaseDate + `",` : ``) + `
                      "brand": "Startup Guide Book",
                      "image": "`+ this.props.picture + `",
                      "offers": {
                          "@type": "Offer",
                          "priceCurrency": "EUR",
                          "price": "`+ this.getPrice(this.state.product) + `",
                          "itemCondition": "http://schema.org/NewCondition",
                          "availability": "http://schema.org/InStock",
                          "url": "https://startupguide.com/shop/startup-guide-`+ this.props.slug + `",
                          "seller": {
                              "@type": "Organization",
                              "name": "Startup Guide"
                          }
                      }
                    }
                    `}</script>
                </Helmet>
                <div style={{ display: "none" }} id="target-product" />
                <div style={{ display: "none" }} id="target-digital-product" />
                <div style={{ display: "none" }} id="target-product-bundle" />

                <div className="book-details---1" style={{ background: this.props.city.color + 'B3' }}>
                    <div className="berlin-_buy">
                        <div className="book-details-2-col w-row">
                            <div className="book-description col--left w-col w-col-6">
                                <img alt="" src={this.props.picture} width={547} className="image-64" />
                            </div>
                            <div className="book-description col--right w-col w-col-6 w-col-medium-6">
                                <div>
                                    <div className="text-block-67">{this.props.name}</div>
                                    <div className="text-block-68">{this.props.variant}</div>
                                </div>
                                <p className="text-description left-aligned">{this.props.summary}</p>
                                <div className="book-cta">
                                    <div className="book-cta-2 w-row" >
                                        {this.props.shopifyProduct &&
                                            <div className="column-64 w-col w-col-6 w-col-stack">
                                                <div className="book-cta-print-version">
                                                    <h3 className="price-description margin-bottom-8px">
                                                        <span className="text-span-2">
                                                            {this.props.productLabel ? this.props.productLabel : 'Paperback'}
                                                            <br />
                                                        </span>
                                                    </h3>
                                                    <div className="book-price-tag">
                                                        <div className="book-price-tag">
                                                            €{this.getPrice(this.state.product)}
                                                        </div>

                                                        <div className={"price-strikethrough " + (this.getComparePrice(this.state.product) === 0 ? "hidden" : '')}>
                                                            €{this.getComparePrice(this.state.product)}
                                                        </div>
                                                        {isPreSale &&
                                                            <span className="text-span-2">PRE-SALE</span>
                                                        }
                                                    </div>
                                                    <button onClick={() => { jQuery('#target-product').find('button').click(); }} className="button small primary book-cta w-inline-block">
                                                        <div className="text-block-3">
                                                            ADD&nbsp;TO&nbsp;BASKET
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.digitalProduct &&
                                            <div className="column-65 w-col w-col-6 w-col-stack">
                                                <div className="book-cta-print-version">
                                                    <h3 className="price-description margin-bottom-8px">
                                                        <span className="text-span-2">
                                                            {this.props.digitalProductLabel ? this.props.digitalProductLabel : 'Digital'}
                                                            <br />
                                                        </span>
                                                    </h3>
                                                    <div className="book-price-tag">
                                                        <div className="book-price-tag">
                                                            €{this.getPrice(this.state.digitalProduct)}
                                                        </div>
                                                        <div className={"price-strikethrough " + (this.getComparePrice(this.state.digitalProduct) === 0 ? "hidden" : '')}>
                                                            €{this.getComparePrice(this.state.digitalProduct)}
                                                        </div>
                                                        {isPreSale &&
                                                            <span className="text-span-2">PRE-SALE</span>
                                                        }
                                                    </div>

                                                    <button onClick={() => { jQuery('#target-digital-product').find('button').click(); }} className="button small primary book-cta w-inline-block">
                                                        <div className="text-block-3">
                                                            ADD&nbsp;TO&nbsp;BASKET
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.shopifyBundle &&
                                            <div className="column-65 w-col w-col-6 w-col-stack">
                                                <div className="book-cta-print-version">
                                                    <h3 className="price-description margin-bottom-8px">
                                                        <span className="text-span-2">
                                                            {this.props.shopifyBundleLabel ? this.props.shopifyBundleLabel : 'Bundle'}
                                                            <br />
                                                        </span>
                                                    </h3>
                                                    <div className="book-price-tag">
                                                        <div className="book-price-tag">
                                                            €{this.getPrice(this.state.variantProduct)}
                                                        </div>
                                                        <div className={"price-strikethrough " + (this.getComparePrice(this.state.variantProduct) === 0 ? "hidden" : '')}>
                                                            €{this.getComparePrice(this.state.variantProduct)}
                                                        </div>
                                                        {isPreSale &&
                                                            <span className="text-span-2">PRE-SALE</span>
                                                        }

                                                    </div>
                                                    <button onClick={() => { jQuery('#target-product-bundle').find('button').click(); }} className="button small primary book-cta w-inline-block">
                                                        <div className="text-block-3">
                                                            ADD&nbsp;TO&nbsp;BASKET
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <div className="moredetails2">
                            <div className="description-text">
                                <div className="div-block-68">
                                    <div className="text-block-71">ABOUT&nbsp;THE&nbsp;BOOK</div>
                                    <p className="paragraph-4" dangerouslySetInnerHTML={{ __html: this.props.description }} />
                                </div>
                                {hasNominations &&
                                    <div
                                        className="div-block-90"
                                        style={{
                                            backgroundColor: this.props.nominationsColor,
                                        }}
                                    >
                                        <div className="text-block-85">NOMINATIONS ARE OPEN</div>
                                        <p className="paragraph-5">
                                            Want to be featured in the first edition of {this.props.name}?
                                            Know someone who should be featured?<br /><br />
                                            Fill in our online nomination form.
                                        </p>
                                        <div className="text-block-87">
                                            <strong className="bold-text-91">
                                                You have until&nbsp;
                                                {moment(this.props.nominationsUntil).format('MMMM Do HH:mm')}
                                            </strong>
                                        </div>
                                        <a href={this.props.nominationsLink} target="_self" className="nominate-now w-button">
                                            NOMINATE NOW
                                        </a>
                                    </div>
                                }
                                {!hasNominations &&
                                    <div className="images---details w-hidden-medium w-hidden-small w-hidden-tiny">
                                        <div className="row-22 w-row">
                                            <div className="column-66 w-col w-col-6 w-col-stack">
                                                {this.props.pictures[0] &&
                                                    <div
                                                        className="div-block-73"
                                                        style={{
                                                            backgroundImage: 'url(' + this.props.pictures[0] + ')'
                                                        }}
                                                    />
                                                }
                                                {this.props.pictures[1] &&
                                                    <div
                                                        className="div-block-78"
                                                        style={{
                                                            backgroundImage: 'url(' + this.props.pictures[1] + ')'
                                                        }}
                                                    />
                                                }
                                            </div>
                                            <div className="column-68 w-col w-col-6 w-col-stack">
                                                {this.props.pictures[2] &&
                                                    <div
                                                        className="div-block-71"
                                                        style={{
                                                            backgroundImage: 'url(' + this.props.pictures[2] + ')'
                                                        }}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="content-ship">
                                <div className="div-block-80" style={{ "paddingBottom": "0", "marginBottom": "-68px" }}>
                                    <div className="text-block-77">CONTENTS</div>
                                    <div className="div-block-81">
                                        {this.props.content.map((c, k) =>
                                            <div key={k} className="content-icones">
                                                <img alt="" src={c.icon} width={40} height={48} className="table-of-contents-image" />
                                                <div className="text-block-78">{c.title}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="div-block-80">
                                    <div className="text-block-77">SHIPPING&nbsp;INFO</div>
                                    <div className="text-block-84">{this.props.shipping}</div>
                                </div>
                            </div>
                            {!hasNominations &&
                                <div className="images---details-2 w-hidden-main">
                                    <div className="row-22 w-row">
                                        <div className="column-66 w-col w-col-6 w-col-stack">
                                            {this.props.pictures[0] &&
                                                <div
                                                    className="div-block-73"
                                                    style={{
                                                        backgroundImage: 'url(' + this.props.pictures[0] + ')'
                                                    }}
                                                />
                                            }
                                            {this.props.pictures[1] &&
                                                <div
                                                    className="div-block-78"
                                                    style={{
                                                        backgroundImage: 'url(' + this.props.pictures[1] + ')'
                                                    }}
                                                />
                                            }
                                        </div>
                                        <div className="column-68 w-col w-col-6 w-col-stack">
                                            {this.props.pictures[2] &&
                                                <div
                                                    className="div-block-71"
                                                    style={{
                                                        backgroundImage: 'url(' + this.props.pictures[2] + ')'
                                                    }}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </LazyLoad>
                }
                {blockLazy &&
                    <div className="moredetails2">
                        <div className="description-text">
                            <div className="div-block-68">
                                <div className="text-block-71">ABOUT&nbsp;THE&nbsp;BOOK</div>
                                <p className="paragraph-4" dangerouslySetInnerHTML={{ __html: this.props.description }} />
                            </div>
                            {hasNominations &&
                                <div
                                    className="div-block-90"
                                    style={{
                                        backgroundColor: this.props.nominationsColor,
                                    }}
                                >
                                    <div className="text-block-85">NOMINATIONS ARE OPEN</div>
                                    <p className="paragraph-5">
                                        Want to be featured in the first edition of {this.props.name}?
                                        Know someone who should be featured?<br /><br />
                                        Fill in our online nomination form.
                                    </p>
                                    <div className="text-block-87">
                                        <strong className="bold-text-91">
                                            You have until&nbsp;
                                            {moment(this.props.nominationsUntil).format('MMMM Do HH:mm')}
                                        </strong>
                                    </div>
                                    <a href={this.props.nominationsLink} target="_blank" className="nominate-now w-button">
                                        NOMINATE NOW
                                    </a>
                                </div>
                            }
                            {!hasNominations &&
                                <div className="images---details w-hidden-medium w-hidden-small w-hidden-tiny">
                                    <div className="row-22 w-row">
                                        <div className="column-66 w-col w-col-6 w-col-stack">
                                            {this.props.pictures[0] &&
                                                <div
                                                    className="div-block-73"
                                                    style={{
                                                        backgroundImage: 'url(' + this.props.pictures[0] + ')'
                                                    }}
                                                />
                                            }
                                            {this.props.pictures[1] &&
                                                <div
                                                    className="div-block-78"
                                                    style={{
                                                        backgroundImage: 'url(' + this.props.pictures[1] + ')'
                                                    }}
                                                />
                                            }
                                        </div>
                                        <div className="column-68 w-col w-col-6 w-col-stack">
                                            {this.props.pictures[2] &&
                                                <div
                                                    className="div-block-71"
                                                    style={{
                                                        backgroundImage: 'url(' + this.props.pictures[2] + ')'
                                                    }}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="content-ship">
                            <div className="div-block-80" style={{ "paddingBottom": "0", "marginBottom": "-68px" }}>
                                <div className="text-block-77">CONTENTS</div>
                                <div className="div-block-81">
                                    {this.props.content.map((c, k) =>
                                        <div key={k} className="content-icones">
                                            <img alt="" src={c.icon} width={40} height={48} className="table-of-contents-image" />
                                            <div className="text-block-78">{c.title}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="div-block-80">
                                <div className="text-block-77">SHIPPING&nbsp;INFO</div>
                                <div className="text-block-84">{this.props.shipping}</div>
                            </div>
                        </div>
                        {!hasNominations &&
                            <div className="images---details-2 w-hidden-main">
                                <div className="row-22 w-row">
                                    <div className="column-66 w-col w-col-6 w-col-stack">
                                        {this.props.pictures[0] &&
                                            <div
                                                className="div-block-73"
                                                style={{
                                                    backgroundImage: 'url(' + this.props.pictures[0] + ')'
                                                }}
                                            />
                                        }
                                        {this.props.pictures[1] &&
                                            <div
                                                className="div-block-78"
                                                style={{
                                                    backgroundImage: 'url(' + this.props.pictures[1] + ')'
                                                }}
                                            />
                                        }
                                    </div>
                                    <div className="column-68 w-col w-col-6 w-col-stack">
                                        {this.props.pictures[2] &&
                                            <div
                                                className="div-block-71"
                                                style={{
                                                    backgroundImage: 'url(' + this.props.pictures[2] + ')'
                                                }}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
                {this.props.preview.length > 0 && !blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <div className="section-7">
                            <div data-animation="slide" data-hide-arrows={1} data-nav-spacing={4} data-duration={500} data-infinite={1} className="slider-4 w-slider">
                                <div className="mask-2 w-slider-mask">
                                    <div className="slide-4 w-slide">
                                        <div className="div-block-79">
                                            <Carousel
                                                style={{ marginTop: 5 }}
                                                slideWidth="524px"
                                                slidesToShow={3}
                                                slidesToScroll="auto"
                                                swiping={true}
                                                withoutControls={true}
                                                slideIndex={this.state.slideIndex}
                                                frameOverflow="visible"
                                                cellSpacing={32}
                                            >
                                                {this.props.preview.map((p, k) =>
                                                    <img alt="" key={k} src={p} className="image-71 shadow" />
                                                )}
                                            </Carousel>
                                        </div>
                                    </div>
                                    <div className="slide-5 w-slide" />
                                </div>
                                <div
                                    className="w-slider-arrow-left"
                                    onClick={() => this.setState({ slideIndex: this.state.slideIndex - 1 })}
                                >
                                    <div className="icon-4 w-icon-slider-left" />
                                </div>
                                <div
                                    className="w-slider-arrow-right"
                                    onClick={() => this.setState({ slideIndex: this.state.slideIndex + 1 })}
                                >
                                    <div className="icon-3 w-icon-slider-right" />
                                </div>
                                <div className="slide-nav-3 w-slider-nav w-round" />
                            </div>
                        </div>
                    </LazyLoad>
                }

                {this.props.preview.length > 0 && blockLazy &&
                    <div className="section-7">
                        <div data-animation="slide" data-hide-arrows={1} data-nav-spacing={4} data-duration={500} data-infinite={1} className="slider-4 w-slider">
                            <div className="mask-2 w-slider-mask">
                                <div className="slide-4 w-slide">
                                    <div className="div-block-79">
                                        <Carousel
                                            style={{ marginTop: 5 }}
                                            slideWidth="524px"
                                            slidesToShow={3}
                                            slidesToScroll="auto"
                                            swiping={true}
                                            withoutControls={true}
                                            slideIndex={this.state.slideIndex}
                                            frameOverflow="visible"
                                            cellSpacing={32}
                                        >
                                            {this.props.preview.map((p, k) =>
                                                <img alt="" key={k} src={p} className="image-71 shadow" />
                                            )}
                                        </Carousel>
                                    </div>
                                </div>
                                <div className="slide-5 w-slide" />
                            </div>
                            <div
                                className="w-slider-arrow-left"
                                onClick={() => this.setState({ slideIndex: this.state.slideIndex - 1 })}
                            >
                                <div className="icon-4 w-icon-slider-left" />
                            </div>
                            <div
                                className="w-slider-arrow-right"
                                onClick={() => this.setState({ slideIndex: this.state.slideIndex + 1 })}
                            >
                                <div className="icon-3 w-icon-slider-right" />
                            </div>
                            <div className="slide-nav-3 w-slider-nav w-round" />
                        </div>
                    </div>
                }

                {this.props.quotes.length > 0 && !blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <div className="section-8">
                            <div className="quotes" style={{ background: this.props.city.color + 'B3' }}>
                                <div>
                                    <div className="div-block-85">
                                        <div className="text-block-80">IN THIS&nbsp;BOOK</div>
                                        <div className="div-block-86" />
                                    </div>
                                    <div className="div-block-83">
                                        {this.props.quotes[0] &&
                                            <div className="quote-1">
                                                <div className="text-block-79">{this.props.quotes[0].quote}</div>
                                                <div className="text-block-81">
                                                    {this.props.quotes[0].author},&nbsp;
                                                    <Link target="_blank" to={this.props.quotes[0].link} className="link-14">
                                                        {this.props.quotes[0].organisation}
                                                    </Link>
                                                </div>
                                            </div>
                                        }
                                        {this.props.quotes[1] &&
                                            <div className="quote-2">
                                                <div className="text-block-79">{this.props.quotes[1].quote}</div>
                                                <div className="text-block-81">
                                                    {this.props.quotes[1].author},&nbsp;
                                                    <Link target="_blank" to={this.props.quotes[1].link} className="link-15">
                                                        {this.props.quotes[1].organisation}
                                                    </Link>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </LazyLoad>
                }
                {this.props.quotes.length > 0 && blockLazy &&
                    <div className="section-8">
                        <div className="quotes" style={{ background: this.props.city.color + 'B3' }}>
                            <div>
                                <div className="div-block-85">
                                    <div className="text-block-80">IN THIS&nbsp;BOOK</div>
                                    <div className="div-block-86" />
                                </div>
                                <div className="div-block-83">
                                    {this.props.quotes[0] &&
                                        <div className="quote-1">
                                            <div className="text-block-79">{this.props.quotes[0].quote}</div>
                                            <div className="text-block-81">
                                                {this.props.quotes[0].author},&nbsp;
                                                <Link target="_blank" to={this.props.quotes[0].link} className="link-14">
                                                    {this.props.quotes[0].organisation}
                                                </Link>
                                            </div>
                                        </div>
                                    }
                                    {this.props.quotes[1] &&
                                        <div className="quote-2">
                                            <div className="text-block-79">{this.props.quotes[1].quote}</div>
                                            <div className="text-block-81">
                                                {this.props.quotes[1].author},&nbsp;
                                                <Link target="_blank" to={this.props.quotes[1].link} className="link-15">
                                                    {this.props.quotes[1].organisation}
                                                </Link>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {!blockLazy && (!this.props.latestArticles.length ||
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <div id="book" className="city-page-block">
                            <div className="div-block-88">
                                <div className="text-block-82" style={{ color: this.props.city.color }}>Latest on </div>
                                <div className="text-block-83" style={{ color: this.props.city.color, textTransform: 'uppercase' }}>
                                    {this.props.city.name}
                                </div>
                            </div>
                            <div className="row-berlin w-row">
                                {this.props.latestArticles.map((a, k) =>
                                    <div key={k} className="column-35 w-col w-col-4">
                                        <Link to={a.link} className="link-block-9 w-inline-block" />
                                        <img alt="" src={a.picture} className="image-headline primary" />
                                        <div className="div-block-16 berlin" style={{ background: this.props.city.color }} />
                                        <div>
                                            <h3 className="heading-9 healines_main">
                                                <strong className="bold-text-89">{a.title}</strong></h3>
                                            <p className="paragraph-3">{a.caption}</p>
                                        </div>
                                        <div className="div-block-15">
                                            <div className="grey">{a.author.firstname} {a.author.lastname}</div>
                                            <img alt="" src={greyTimeIcon} width={13} height={13} className="image-24" />
                                            <div className="grey2">{a.readingTime}</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="discover-berlin w-container">
                                <Link
                                    to={this.props.city.link}
                                    data-w-id="c2569bfb-2bb7-ef91-61f2-44e1d80f2ea5"
                                    className="explore berlin w-button"
                                    onMouseEnter={() => this.setState({ exploreButtonHover: true })}
                                    onMouseLeave={() => this.setState({ exploreButtonHover: false })}
                                    style={{
                                        textTransform: 'uppercase',
                                        borderColor: this.props.city.color,
                                        background: (this.state && this.state.exploreButtonHover ?
                                            '#ffffff' :
                                            this.props.city.color
                                        ),
                                        color: (this.state && this.state.exploreButtonHover ?
                                            this.props.city.color :
                                            '#ffffff'
                                        )
                                    }}
                                >
                                    EXPLORE&nbsp;{this.props.city.name}
                                </Link>
                            </div>
                        </div>
                    </LazyLoad>
                )}
                {blockLazy && (!this.props.latestArticles.length ||
                    <div id="book" className="city-page-block">
                        <div className="div-block-88">
                            <div className="text-block-82" style={{ color: this.props.city.color }}>Latest on </div>
                            <div className="text-block-83" style={{ color: this.props.city.color, textTransform: 'uppercase' }}>
                                {this.props.city.name}
                            </div>
                        </div>
                        <div className="row-berlin w-row">
                            {this.props.latestArticles.map((a, k) =>
                                <div key={k} className="column-35 w-col w-col-4">
                                    <Link to={a.link} className="link-block-9 w-inline-block" />
                                    <img alt="" src={a.picture} className="image-headline primary" />
                                    <div className="div-block-16 berlin" style={{ background: this.props.city.color }} />
                                    <div>
                                        <h3 className="heading-9 healines_main">
                                            <strong className="bold-text-89">{a.title}</strong></h3>
                                        <p className="paragraph-3">{a.caption}</p>
                                    </div>
                                    <div className="div-block-15">
                                        { a.author && (
                                            <div className="grey">{a.author.firstname} {a.author.lastname}</div>
                                        )}
                                        <img alt="" src={greyTimeIcon} width={13} height={13} className="image-24" />
                                        <div className="grey2">{a.readingTime}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="discover-berlin w-container">
                            <Link
                                to={this.props.city.link}
                                data-w-id="c2569bfb-2bb7-ef91-61f2-44e1d80f2ea5"
                                className="explore berlin w-button"
                                onMouseEnter={() => this.setState({ exploreButtonHover: true })}
                                onMouseLeave={() => this.setState({ exploreButtonHover: false })}
                                style={{
                                    textTransform: 'uppercase',
                                    borderColor: this.props.city.color,
                                    background: (this.state && this.state.exploreButtonHover ?
                                        '#ffffff' :
                                        this.props.city.color
                                    ),
                                    color: (this.state && this.state.exploreButtonHover ?
                                        this.props.city.color :
                                        '#ffffff'
                                    )
                                }}
                            >
                                EXPLORE&nbsp;{this.props.city.name}
                            </Link>
                        </div>
                    </div>
                )}

                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <div id="book" className="city-book-sponsors">
                            <div className="div-block-135">
                                <div className="supported-by">
                                    {this.props.sponsors.length > 0 &&
                                        <div>
                                            <h2 className="heading margin-bottom-16px">Proudly supported by:</h2>
                                            <div className="logos">
                                                {this.props.sponsors.map((s, k) =>
                                                    <a key={k} href={s.link} target="_blank">
                                                        <img alt="" key={k} src={s.logo} width={185} className="image-79" />
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="community-partner">
                                    {this.props.communityPartners.length > 0 &&
                                        <div>
                                            <h2 className="heading margin-bottom-16px">Community Partners:</h2>
                                            <div className="logos">
                                                {this.props.communityPartners.map((p, k) =>
                                                    <a key={k} href={p.link} target="_blank">
                                                        <img alt="" src={p.logo} width={185} className="image-79" />
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </LazyLoad>
                }
                {blockLazy &&
                    <div id="book" className="city-book-sponsors">
                        <div className="div-block-135">
                            <div className="supported-by">
                                {this.props.sponsors.length > 0 &&
                                    <div>
                                        <h2 className="heading margin-bottom-16px">Proudly supported by:</h2>
                                        <div className="logos">
                                            {this.props.sponsors.map((s, k) =>
                                                <a key={k} href={s.link} target="_blank">
                                                    <img alt="" key={k} src={s.logo} width={185} className="image-79" />
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="community-partner">
                                {this.props.communityPartners.length > 0 &&
                                    <div>
                                        <h2 className="heading margin-bottom-16px">Community Partners:</h2>
                                        <div className="logos">
                                            {this.props.communityPartners.map((p, k) =>
                                                <a key={k} href={p.link} target="_blank">
                                                    <img alt="" src={p.logo} width={185} className="image-79" />
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const connectRelay = ProductPage => class extends Component {

    render() {
        const { routeResolver } = this.props.context
        // console.log(this.props);
        const props = {
            context: this.props.context,
            name: this.props.product.name,
            variant: this.props.product.variant,
            summary: this.props.product.summary,
            description: this.props.product.description,
            releaseDate: this.props.product.releaseDate,
            shippingFromDate: this.props.product.shippingFromDate,
            discountInfo: this.props.product.discountInfo,
            nominationsUntil: this.props.product.nominationsUntil,
            nominationsLink: this.props.product.nominationsLink,
            nominationsColor: this.props.product.nominationsColor,
            picture: this.props.product.picture,
            shopifyProduct: this.props.product.shopifyProduct,
            shopifyDigitalProduct: this.props.product.shopifyDigitalProduct,
            productLabel: this.props.product.productLabel,
            digitalProductLabel: this.props.product.digitalProductLabel,
            shopifyBundle: this.props.product.shopifyBundle,
            shopifyBundleLabel: this.props.product.shopifyBundleLabel,
            city: {
                link: routeResolver.location.get(this.props.product.city.slug),
                ...this.props.product.city
            },
            shipping: this.props.product.shipping,
            pictures: this.props.product.pictures,
            content: this.props.product.content,
            preview: this.props.product.preview,
            quotes: this.props.product.quotes,
            latestArticles: this.props.product.city.articles.map(a => ({
                ...a,
                link: routeResolver.article.get(this.props.product.city.slug, a.slug),
                readingTime: msToReadingTime(a.readingTime),
            })),
            sponsors: this.props.product.sponsors,
            communityPartners: this.props.product.communityPartners,
            seo: this.props.product.seo,
            generic: this.props.product.social.generic[0],
            slug: this.props.product.city.slug,
            twitter: this.props.product.social.twitter[0]
        }

        console.log("PROP?", props);

        return <ProductPage {...props} />
    }
}

export default createFragmentContainer(
    connectRelay(ProductPage),
    graphql`
        fragment productPage_product on Product {
            slug
            name
            variant
            summary
            description
            releaseDate
            shippingFromDate
            discountInfo
            nominationsUntil
            nominationsLink
            nominationsColor
            picture
            shopifyProduct
            shopifyDigitalProduct
            productLabel
            digitalProductLabel
            shopifyBundle
            shopifyBundleLabel
            seo {
                title
                description
            }
            social {
                twitter {
                    type
                    title
                    image
                    handle
                    description
                }
                generic {
                    title
                    image
                    description
                }
            }
            city {
                slug
                name
                color
                articles(first: 3) {
                    slug
                    title
                    caption
                    readingTime
                    picture
                    author {
                        firstname
                        lastname
                    }
                }
            }
            shipping
            pictures
            content {
                title
                icon
            }
            preview
            quotes {
                quote
                author
                organisation
                link
            }
            sponsors {
                logo
                link
            }
            communityPartners {
                logo
                link
            }
        }
    `
)